module.exports = __webpack_public_path__ + "static/media/bg.4df78743.png";